import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import { toast, ToastContainer } from "react-toastify";
import { Link } from "react-router-dom";
import TeacherMenu from "./TeacherMenu";

const UpdateProfile = (props) => {
  const [AccessKey, setAccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID, setUserID] = useState(localStorage.getItem("ID"));
  const [MemberType, setMemberType] = useState(
    localStorage.getItem("MemberType")
  );
  const [loading, setLoading] = useState(false);
  const [Employee, setEmployee] = useState({});

  const staffId = parseInt(UserID, 10) || 0;

  useEffect(() => {
    if (!AccessKey || !staffId) {
      toast.error("Session expired. Please log in again.", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }

    const data = {
      AccessKey: AccessKey,
      UserID: staffId,
      MemberType: MemberType || "Teacher",
      // Payroll API loads staff by this id (same as logged-in teacher staff id)
      ID: staffId,
    };
    setLoading(true);
    var api_config = {
      method: "post",
      url: config.base_url + "Payroll/GetEmployeeByID",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(api_config)
      .then(function (response) {
        const sc = response.data.status_code;
        if (sc === 1 || sc === "1") {
          setEmployee(response.data.Employee || {});
        } else {
          setEmployee({});
          toast.error(
            response.data.status_message || "Could not load your profile.",
            { position: toast.POSITION.TOP_RIGHT }
          );
        }
        setLoading(false);
      })
      .catch(function (error) {
        setLoading(false);
        setEmployee({});
        toast.error("Network error while loading profile.", {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  }, [AccessKey, staffId, MemberType]);

  const str = (v) => (v == null || v === undefined ? "" : String(v));
  const genderLabel =
    Employee.Gender === true
      ? "Male"
      : Employee.Gender === false
      ? "Female"
      : "";

  return (
    <>
      <TeacherMenu />
      <ToastContainer />
      <div className="container body-content">
        <div className="page-head">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/teacher/dashboard">Home</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Update Profile
                    </li>
                  </ol>
                </nav>
                <div className="page-title">Update Profile</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="page-content">
        <div className="container">
          <div className="card">
            <div className="card-body p-md-4">
              <p className="text-muted small mb-3">
                Profile is read-only here. Use <strong>Update Photo</strong> for
                picture changes; contact HR for corrections to service records.
              </p>
              {loading ? (
                <div className="text-center py-5">
                  <Spinner animation="border" role="status" />
                </div>
              ) : (
              <div className="row">
                <div className="col-md-3">
                  <div className="form-group mb-3">
                    <label htmlFor="">Employee Code:</label>
                    <input
                      value={str(Employee.Code)}
                      readOnly
                      className="form-control"
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group mb-3">
                    <label htmlFor="">Employee Name:</label>
                    <input
                      value={str(Employee.Name)}
                      readOnly
                      className="form-control"
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group mb-3">
                    <label htmlFor="">Father Name:</label>
                    <input
                      value={str(Employee.Father_Name)}
                      readOnly
                      className="form-control"
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group mb-3">
                    <label htmlFor="">Husband Name:</label>
                    <input type="text" className="form-control" readOnly value={str(Employee.Husband_Name)} />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group mb-3">
                    <label htmlFor="">Marital Status:</label>
                    <input
                      type="text"
                      className="form-control"
                      readOnly
                      value={str(Employee.Marital_Status)}
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group mb-3">
                    <label htmlFor="">Gender:</label>
                    <input
                      type="text"
                      className="form-control"
                      readOnly
                      value={genderLabel}
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group mb-3">
                    <label htmlFor="">Designation :</label>
                    <input
                      type="text"
                      className="form-control"
                      readOnly
                      value={str(Employee.Selected_Designation?.Name)}
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group mb-3">
                    <label htmlFor="">Blood Group:</label>
                    <input type="text" className="form-control" readOnly value={str(Employee.Blood_Group)} />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group mb-3">
                    <label htmlFor="">CNIC No:</label>
                    <input
                      type="text"
                      readOnly
                      value={str(Employee.CNIC_NO)}
                      className="form-control"
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group mb-3">
                    <label htmlFor="">Bank Account No:</label>
                    <input
                      type="text"
                      readOnly
                      value={str(Employee.Account_No)}
                      className="form-control"
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group mb-3">
                    <label htmlFor="">EOBI No:</label>
                    <input type="text" className="form-control" value={str(Employee.EOBI_NO)} readOnly />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group mb-3">
                    <label htmlFor="">NTN NO:</label>
                    <input type="text" className="form-control" value={str(Employee.NTN_NO)} readOnly />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group mb-3">
                    <label htmlFor="">Phone No:</label>
                    <input type="text" className="form-control" value={str(Employee.Phone_No)} readOnly />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group mb-3">
                    <label htmlFor="">Mobile No:</label>
                    <input type="text" className="form-control" value={str(Employee.Mobile_No)} readOnly />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group mb-3">
                    <label htmlFor=""> Pay Scale :</label>
                    <input
                      type="text"
                      readOnly
                      value={str(Employee.GPS_Scale)}
                      className="form-control"
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group mb-3">
                    <label htmlFor="">Group / Department:</label>
                    <input
                      type="text"
                      className="form-control"
                      readOnly
                      value={str(
                        Employee.Employee_Type_BE?.Name || Employee.Department
                      )}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group mb-6">
                    <label htmlFor="">Home Address:</label>
                    <input type="text" className="form-control" value={str(Employee.Home_Address)} readOnly />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group mb-6">
                    <label htmlFor="">Qualification :</label>
                    <input type="text" className="form-control" value={str(Employee.Qualification)} readOnly />
                  </div>
                </div>
               
              </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* <div className="page-content">
        <div className="container">
          <div className="row">
            <div className="col-md-10 offset-md-1">
              <div className="card mb-3">
                <div className="card-body card-form-wrap">
                  <div className="form-wrap mb-md-0">
                    <div className="row align-items-center">
                      <label htmlFor="" className="col-md-2 col-form-label col-form-label-sm">
                        Employee Code:
                      </label>
                      <div className="col-md-4">
                        <label className="label-value">
                          @Model.Code
                        </label>
                      </div>
                      <label htmlFor="" className="col-md-2 col-form-label col-form-label-sm">
                        Employee Name:
                      </label>
                      <div className="col-md-4">
                        <label className="label-value">
                          @Model.Name
                        </label>
                      </div>
                    </div>
                    <div className="row align-items-center">
                      <label htmlFor="" className="col-md-2 col-form-label col-form-label-sm">
                        Father Name:
                      </label>
                      <div className="col-md-4">
                        <label className="label-value">
                          @Model.Father_Name
                        </label>
                      </div>
                      <label htmlFor="" className="col-md-2 col-form-label col-form-label-sm">
                        Husband Name:
                      </label>
                      <div className="col-md-4">
                        <input type="text" className="bg-white form-control" />

                      </div>
                    </div>
                    <div className="row align-items-center">
                      <label htmlFor="" className="col-md-2 col-form-label col-form-label-sm">
                        Marital Status:
                      </label>
                      <div className="col-md-4">
                        <select className="form-select">
                          <option value="Not Available">Not Available</option>
                          <option value="Single">Single</option>
                          <option value="Married">Married</option>
                          <option value="Divorced">Divorced</option>
                          <option value="Widowed">Widowed</option>

                        </select>
                      </div>
                      <label htmlFor="" className="col-md-2 col-form-label col-form-label-sm">
                        Gender:
                      </label>
                      <div className="col-md-4">
                        <label className="label-value">
                          @if (@Model.Gender == true)
                          {
                            <p className="m-0">Male</p>
                          }
                          else
                          {
                            <p className="m-0">Female</p>
                          }
                        </label>
                      </div>
                    </div>
                    <div className="row align-items-center">
                      <label htmlFor="" className="col-md-2 col-form-label col-form-label-sm">
                        Designation :
                      </label>
                      <div className="col-md-4">
                        <label className="label-value">
                          @Model.Selected_Designation.Name
                        </label>
                      </div>
                      <label htmlFor="" className="col-md-2 col-form-label col-form-label-sm">
                        Blood Group:
                      </label>
                      <div className="col-md-4">
                        <input type="text" className=" bg-white form-control" />
                      </div>
                    </div>
                    <div className="row align-items-center">
                      <label htmlFor="" className="col-md-2 col-form-label col-form-label-sm">
                        CNIC No:
                      </label>
                      <div className="col-md-4">
                        <label className="label-value">
                          @Model.CNIC_NO
                        </label>
                      </div>
                      <label htmlFor="" className="col-md-2 col-form-label col-form-label-sm">
                        Bank Account No:
                      </label>
                      <div className="col-md-4">
                        <label className="label-value">
                          @Model.Account_No
                        </label>
                      </div>
                    </div>
                    <div className="row align-items-center">
                      <label htmlFor="" className="col-md-2 col-form-label col-form-label-sm">
                        EOBI No:
                      </label>
                      <div className="col-md-4">
                        <input type="text" className="form-control bg-white"
                        />
                      </div>
                      <label htmlFor="" className="col-md-2 col-form-label col-form-label-sm">
                        NTN NO:
                      </label>
                      <div className="col-md-4">
                        <input type="text" className="form-control bg-white"
                        />
                      </div>
                    </div>
                    <div className="row align-items-center">
                      <label htmlFor="" className="col-md-2 col-form-label col-form-label-sm">
                        Phone No:
                      </label>
                      <div className="col-md-4">
                        <input type="text" className="form-control bg-white"
                        />
                      </div>
                      <label htmlFor="" className="col-md-2 col-form-label col-form-label-sm">
                        Mobile No:
                      </label>
                      <div className="col-md-4">
                        <input type="text" className="form-control bg-white"
                        />
                      </div>
                    </div>
                    <div className="row align-items-center">
                      <label htmlFor="" className="col-md-2 col-form-label col-form-label-sm">
                        Pay Scale :
                      </label>
                      <div className="col-md-4">
                        <label className="label-value">
                          @Model.Basic_Pay_Scale
                        </label>
                      </div>
                      <label htmlFor="" className="col-md-2 col-form-label col-form-label-sm">
                        Group/Depart.:
                      </label>
                      <div className="col-md-4">
                        <label className="label-value">
                          @Model.Department
                        </label>
                      </div>
                    </div>
                    <div className="row align-items-center">
                      <label htmlFor="" className="col-md-2 col-form-label col-form-label-sm">
                        Home Address:
                      </label>
                      <div className="col-md-10">
                        <input name="txtHomeAddress"
                          className="form-control bg-white"></input>
                      </div>
                    </div>
                    <div className="row align-items-center">
                      <label htmlFor="" className="col-md-2 col-form-label col-form-label-sm">
                        Qualification :
                      </label>
                      <div className="col-md-10">
                        <input name="txtQualification"

                          className="form-control bg-white"></input>
                      </div>
                    </div>
                    <div className="row align-items-center mb-md-0">
                      <div className="col-md-3 offset-md-9 text-end">
                        <input type="submit" name="btnSave"

                          value="Save" id="btnSave" className="button button-primary " />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
    </>
  );
};

export default UpdateProfile;
